module.exports = __webpack_public_path__ + "static/hero-border-gray-bec31a55d781c10b39680a3ba95902c3.svg";